module.exports = __webpack_public_path__ + "static/img/11_4Archive_3b_KaprowRecordedSpeech_I_Communication_1958_1.9a4377a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow/archive/11_4Archive_3b_KaprowRecordedSpeech_I_Communication_1958_1.jpg
// module id = 0pRL
// module chunks = 0